import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import VScrollLock from "v-scroll-lock";
// import VModal from "vue-js-modal";
import VModal from "./components/modalsrc";
import VueCookies from "vue-cookies";
import browserDetect from "vue-browser-detect-plugin";
import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

// import "./assets/chota_n.css";
import "./assets/configurator.css";

Vue.config.productionTip = false;
Vue.use(VScrollLock, {
  bodyScrollOptions: {
    reserveScrollBarGap: true,
  },
});
Vue.use(Toast, {
  transition: "Vue-Toastification__fade",
  maxToasts: 2,
  newestOnTop: true,
});
Vue.use(VModal, { dialog: true });
Vue.use(VueCookies);
// set secure, only https works
Vue.$cookies.config("1y", "/", "", "", "Lax"); // default: expireTimes = 1d, path = '/', domain = '', secure = '', sameSite = 'Lax'

Vue.use(browserDetect);
Vue.directive("numericOnly", {
  //eg;  v-numeric or spec max; v-numeric:max="5"
  bind(el, binding) {
    el.addEventListener("keyup", () => {
      let regex = /^[0-9]*$/;
      if (!regex.test(el.value)) {
        el.value = el.value.slice(0, -1);
      }
      //default maximum of 50 unless :max is set
      if (binding.arg != "max") {
        el.value = el.value > 50 ? 50 : el.value;
      } else {
        el.value = el.value > binding.value ? binding.value : el.value;
      }
    });
  },
});
new Vue({
  router,
  store,
  data: {
    request_id: 0,
    chassis_id: 0,
    token: "",
    chassis_name: "",
    request_name: "",
    preventNav: false,
  },
  render: (h) => h(App),
}).$mount("#app");
